import { createModelSegment } from 'client/data/luckdragon/segment';

export const XHeaders = createModelSegment('xHeaders', []);
